
// eslint-disable-next-line import/no-cycle
import Router from '@/router';

export default {
  name: 'HotelView',
  metaInfo: {
    title: 'Hotel Artwork',
  },
  methods: {
    routeToView(viewName: string) {
      Router.push(viewName);
    },
  },
};
